import type { ComponentChildren } from 'preact'
import * as styles from './text-button.module.css'

interface TextButtonProps {
  onClick: (event: MouseEvent) => void
  children: ComponentChildren
  variant?: 'error'
}

export function TextButton({ onClick, children, variant }: TextButtonProps) {
  return (
    <button
      type='button'
      class={variant === 'error' ? styles.textButtonError : styles.textButton}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
